import { arrayOf, shape, string } from "prop-types"

import { date } from "../date"
import { uuid } from "../uuid"

export const document = shape({
    uuid: uuid.isRequired,
    created_by: string,
    mime_type: string,
    document_type: string,
    file: string,
    attached_object_content_type: string,
    attached_object_pk: string,
    date: date,
    tags: arrayOf(string),
    filename: string,
})

